module.exports = __webpack_public_path__ + "static/media/roboto-500italic.db4a2a23.woff2";